/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getPurchaseOrder = /* GraphQL */ `query GetPurchaseOrder($purchase_order_id: ID!) {
  getPurchaseOrder(purchase_order_id: $purchase_order_id) {
    acknowledged_at
    approvals {
      approval_type
      approved_at
      approver_alias
      approver_name
      id
      position
      status
    }
    budget_line_id
    budget_type
    cost_center
    country_code
    created_at
    currency_code
    fiscal_year
    id
    ofa_vendor_number
    order_lines {
      account_code
      budget_type
      commodity_id
      commodity_item
      commodity_type
      cost_center
      created_at
      currency_code
      description
      id
      line_num
      need_by_date
      price
      quantity
      total
      updated_at
    }
    payment_terms
    po_number
    region
    requester_alias
    requester_id
    requisition_id
    shipping_address_id
    status
    supplier_entity_id
    supplier_name
    total
    updated_at
  }
}
` as GeneratedQuery<
  APITypes.GetPurchaseOrderQueryVariables,
  APITypes.GetPurchaseOrderQuery
>;
export const getPurchaseRequisition = /* GraphQL */ `query GetPurchaseRequisition($requisition_id: ID!) {
  getPurchaseRequisition(requisition_id: $requisition_id) {
    amazon_supplier_display_name
    amazon_supplier_entity_id
    anti_corruption_report_link
    approvals {
      approval_type
      approved_at
      approver_alias
      approver_name
      id
      position
      status
    }
    budget_line_id
    business_justification
    cash_donation_or_grant
    cash_sponsorship
    chart_of_accounts
    chart_of_accounts_name
    community_giving_pre_approval_link
    contains_gift
    country_code
    created_at
    currency_code
    current_approval {
      approval_type
      approved_at
      approver_alias
      approver_name
      id
      position
      status
    }
    dealing_with_government
    description_of_what_purchase_order_includes
    gift_approval_link
    gift_over_limit
    id
    local_currency_total
    marketing_info {
      amazon_approval_request_link
      contract_reviewed_and_signed
      media_channel
      purchase_order_guidelines_met
      vendor_confirmation
    }
    multiyear_po
    name
    ofa_vendor_number
    org_id
    payment_terms
    personal_service_company_engagement
    po_number
    region
    requester_alias
    requester_id
    requisition_lines {
      account_allocations {
        account_code
        cost_center
        percentage
        project_code
      }
      account_code
      budget_line_id
      calendar_year
      commodity_id
      commodity_item
      commodity_name
      commodity_type
      cost_center
      description
      end_date
      estimated_invoice_date
      forecast {
        amount
        month_id
      }
      good_or_service
      id
      line_num
      need_by_date
      payment_schedule
      quantity
      quantity_mode
      start_date
      status
      sub_budget_id
      supplier_entity_id
      supplier_name
      team_budget_id
      total
      unit_of_measurement
      unit_price
      unit_price_in_usd
    }
    send_text_to_supplier
    shipping_address_id
    status
    submitted_at
    supplier_text
    total
    updated_at
  }
}
` as GeneratedQuery<
  APITypes.GetPurchaseRequisitionQueryVariables,
  APITypes.GetPurchaseRequisitionQuery
>;
export const listAccessRequests = /* GraphQL */ `query ListAccessRequests($filter: AccessRequestFilter) {
  listAccessRequests(filter: $filter) {
    approval_reason
    audit_events {
      action
      actor_alias
      actor_name
      details
      event_id
      timestamp
    }
    business_group_name
    created_at
    data_classification_id
    granted_corp_segments
    granted_role
    justification
    rejection_reason
    request_id
    requested_corp_segments
    requested_role
    requester_alias
    requester_name
    reviewed_at
    reviewer_alias
    reviewer_name
    status
    updated_at
    user_alias
    user_name
  }
}
` as GeneratedQuery<
  APITypes.ListAccessRequestsQueryVariables,
  APITypes.ListAccessRequestsQuery
>;
export const listActualsFilterData = /* GraphQL */ `query ListActualsFilterData($data_classification_id: Int!) {
  listActualsFilterData(data_classification_id: $data_classification_id) {
    actual_months
    cost_center {
      cost_center_code
      cost_center_description
    }
    product_line {
      product_code
      product_description
    }
  }
}
` as GeneratedQuery<
  APITypes.ListActualsFilterDataQueryVariables,
  APITypes.ListActualsFilterDataQuery
>;
export const listAnnouncementDetails = /* GraphQL */ `query ListAnnouncementDetails {
  listAnnouncementDetails {
    announcement_date
    announcement_id
    announcement_message
    announcement_title
    data_classification {
      data_classification_id
      data_classification_name
    }
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
  }
}
` as GeneratedQuery<
  APITypes.ListAnnouncementDetailsQueryVariables,
  APITypes.ListAnnouncementDetailsQuery
>;
export const listAuditLogDetails = /* GraphQL */ `query ListAuditLogDetails {
  listAuditLogDetails {
    additional_info
    audit_log_id
    created_at
    created_by
    data_classification_id
    operation_type
    page_name
    record_count
    status
  }
}
` as GeneratedQuery<
  APITypes.ListAuditLogDetailsQueryVariables,
  APITypes.ListAuditLogDetailsQuery
>;
export const listBudgetOwners = /* GraphQL */ `query ListBudgetOwners {
  listBudgetOwners {
    budget_owner
    cost_centers
    data_classification_id
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetOwnersQueryVariables,
  APITypes.ListBudgetOwnersQuery
>;
export const listBudgetTypeDetails = /* GraphQL */ `query ListBudgetTypeDetails {
  listBudgetTypeDetails {
    account_code
    budget_type
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetTypeDetailsQueryVariables,
  APITypes.ListBudgetTypeDetailsQuery
>;
export const listBusinessGroups = /* GraphQL */ `query ListBusinessGroups {
  listBusinessGroups {
    business_segments {
      business_segment_data_type
      business_segment_id
      business_segment_name
      business_segment_name_key
      business_segment_values_s3_path
      is_id_column
    }
    corp_segments {
      corp_segment_data_type
      corp_segment_default_value {
        segment_description
        segment_hierarchy
      }
      corp_segment_id
      corp_segment_name
      corp_segment_name_key
      corp_segment_required
      corp_segment_values_s3_path
    }
    data_classification {
      data_classification_description
      data_classification_id
      data_classification_name
      data_classification_short_description
    }
    display_order_id
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    status
  }
}
` as GeneratedQuery<
  APITypes.ListBusinessGroupsQueryVariables,
  APITypes.ListBusinessGroupsQuery
>;
export const listCommodityDetails = /* GraphQL */ `query ListCommodityDetails {
  listCommodityDetails {
    commodity
    commodity_id
    created_at
    created_by
    description
    is_active
    updated_at
    updated_by
  }
}
` as GeneratedQuery<
  APITypes.ListCommodityDetailsQueryVariables,
  APITypes.ListCommodityDetailsQuery
>;
export const listContactDetails = /* GraphQL */ `query ListContactDetails {
  listContactDetails {
    contact_id
    data_classification_id
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    other_contacts {
      contact_alias
      contact_name
    }
    primary_contact {
      contact_alias
      contact_name
    }
  }
}
` as GeneratedQuery<
  APITypes.ListContactDetailsQueryVariables,
  APITypes.ListContactDetailsQuery
>;
export const listCountryCompanyMapping = /* GraphQL */ `query ListCountryCompanyMapping {
  listCountryCompanyMapping {
    company_code
    country_code
    country_company_id
  }
}
` as GeneratedQuery<
  APITypes.ListCountryCompanyMappingQueryVariables,
  APITypes.ListCountryCompanyMappingQuery
>;
export const listCoupaCategories = /* GraphQL */ `query ListCoupaCategories($org_id: String!) {
  listCoupaCategories(org_id: $org_id) {
    categories {
      id
      item
      label
      type
    }
  }
}
` as GeneratedQuery<
  APITypes.ListCoupaCategoriesQueryVariables,
  APITypes.ListCoupaCategoriesQuery
>;
export const listCurrentScenarios = /* GraphQL */ `query ListCurrentScenarios($dataClassificationId: Int!) {
  listCurrentScenarios(dataClassificationId: $dataClassificationId) {
    scenario_name
    scenario_seq_id
  }
}
` as GeneratedQuery<
  APITypes.ListCurrentScenariosQueryVariables,
  APITypes.ListCurrentScenariosQuery
>;
export const listDMMCampaignDimensions = /* GraphQL */ `query ListDMMCampaignDimensions {
  listDMMCampaignDimensions {
    created_at
    created_by
    data_classification_id
    dimension_id
    dimension_key
    dimension_name
    dimension_values {
      conditional_relationship {
        dimension_id
        dimension_key
        invalid_values
        valid_values
      }
      value
      value_desc
    }
    is_active
    is_required
    updated_at
    updated_by
  }
}
` as GeneratedQuery<
  APITypes.ListDMMCampaignDimensionsQueryVariables,
  APITypes.ListDMMCampaignDimensionsQuery
>;
export const listDMMCampaignsMetadata = /* GraphQL */ `query ListDMMCampaignsMetadata {
  listDMMCampaignsMetadata {
    campaigns_metadata_key
    campaigns_metadata_name
    campaigns_metadata_value
  }
}
` as GeneratedQuery<
  APITypes.ListDMMCampaignsMetadataQueryVariables,
  APITypes.ListDMMCampaignsMetadataQuery
>;
export const listExpenseTypeDetails = /* GraphQL */ `query ListExpenseTypeDetails {
  listExpenseTypeDetails {
    budget_type
    created_at
    created_by
    data_classification_id
    description
    expense_type
    expense_type_id
    is_active
    updated_at
    updated_by
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseTypeDetailsQueryVariables,
  APITypes.ListExpenseTypeDetailsQuery
>;
export const listForecastPlanningCycles = /* GraphQL */ `query ListForecastPlanningCycles {
  listForecastPlanningCycles {
    data_classification_id
    scenario_seq_id
  }
}
` as GeneratedQuery<
  APITypes.ListForecastPlanningCyclesQueryVariables,
  APITypes.ListForecastPlanningCyclesQuery
>;
export const listFxRates = /* GraphQL */ `query ListFxRates {
  listFxRates {
    rates {
      currency_code
      exchange_rate
    }
  }
}
` as GeneratedQuery<
  APITypes.ListFxRatesQueryVariables,
  APITypes.ListFxRatesQuery
>;
export const listLineItemIds = /* GraphQL */ `query ListLineItemIds($data_classification_id: Int!) {
  listLineItemIds(data_classification_id: $data_classification_id) {
    cost_center_code
    xpt_line_item_id
  }
}
` as GeneratedQuery<
  APITypes.ListLineItemIdsQueryVariables,
  APITypes.ListLineItemIdsQuery
>;
export const listMasterSegments = /* GraphQL */ `query ListMasterSegments {
  listMasterSegments {
    description
    segment_category
    segment_data_type
    segment_hierarchy_s3_path
    segment_id
    segment_name
    segment_name_key
  }
}
` as GeneratedQuery<
  APITypes.ListMasterSegmentsQueryVariables,
  APITypes.ListMasterSegmentsQuery
>;
export const listMetadata = /* GraphQL */ `query ListMetadata {
  listMetadata {
    id
    key
    value
  }
}
` as GeneratedQuery<
  APITypes.ListMetadataQueryVariables,
  APITypes.ListMetadataQuery
>;
export const listMyAccessRequestSubmissions = /* GraphQL */ `query ListMyAccessRequestSubmissions {
  listMyAccessRequestSubmissions {
    approval_reason
    audit_events {
      action
      actor_alias
      actor_name
      details
      event_id
      timestamp
    }
    business_group_name
    created_at
    data_classification_id
    granted_corp_segments
    granted_role
    justification
    rejection_reason
    request_id
    requested_corp_segments
    requested_role
    requester_alias
    requester_name
    reviewed_at
    reviewer_alias
    reviewer_name
    status
    updated_at
    user_alias
    user_name
  }
}
` as GeneratedQuery<
  APITypes.ListMyAccessRequestSubmissionsQueryVariables,
  APITypes.ListMyAccessRequestSubmissionsQuery
>;
export const listMyAccessRequests = /* GraphQL */ `query ListMyAccessRequests {
  listMyAccessRequests {
    approval_reason
    audit_events {
      action
      actor_alias
      actor_name
      details
      event_id
      timestamp
    }
    business_group_name
    created_at
    data_classification_id
    granted_corp_segments
    granted_role
    justification
    rejection_reason
    request_id
    requested_corp_segments
    requested_role
    requester_alias
    requester_name
    reviewed_at
    reviewer_alias
    reviewer_name
    status
    updated_at
    user_alias
    user_name
  }
}
` as GeneratedQuery<
  APITypes.ListMyAccessRequestsQueryVariables,
  APITypes.ListMyAccessRequestsQuery
>;
export const listMyNotifications = /* GraphQL */ `query ListMyNotifications {
  listMyNotifications {
    event
    is_persistent
    is_read
    notification_id
    payload
    recipient_aliases
    source
  }
}
` as GeneratedQuery<
  APITypes.ListMyNotificationsQueryVariables,
  APITypes.ListMyNotificationsQuery
>;
export const listPlanningCycles = /* GraphQL */ `query ListPlanningCycles {
  listPlanningCycles {
    actuals_end_month_id
    actuals_start_month_id
    baseline_scenario {
      baseline_scenario_name
      baseline_scenario_seq_id
    }
    budget_editable_end_month
    budget_editable_start_month
    budget_owner_lock_date
    created_at
    created_by
    data_classification {
      data_classification_description
      data_classification_id
      data_classification_name
      data_classification_short_description
    }
    extended_user_lists
    forecast_data_available
    forecast_end_month_id
    forecast_start_month_id
    is_active
    is_budget_leader_owner_editable
    is_extended
    is_prophecy_enabled
    last_synced_to_prophecy {
      last_synced_to_prophecy
      load_type
    }
    planning_cycle_extended_date
    planning_cycle_lock_date
    planning_cycle_open_date
    planning_cycle_year
    prophecy_actuals_end_month_id
    prophecy_actuals_start_month_id
    prophecy_created_at
    prophecy_created_by
    prophecy_forecast_end_month_id
    prophecy_forecast_start_month_id
    scenario {
      planning_cycle_name
      scenario_id
      scenario_name
    }
    scenario_seq_id
    updated_at
    updated_by
  }
}
` as GeneratedQuery<
  APITypes.ListPlanningCyclesQueryVariables,
  APITypes.ListPlanningCyclesQuery
>;
export const listReportViews = /* GraphQL */ `query ListReportViews($data_classification_id: Int!, $data_source_id: String) {
  listReportViews(
    data_classification_id: $data_classification_id
    data_source_id: $data_source_id
  ) {
    data_source_id
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    name
    schema_version
    state
    view_id
    visibility
  }
}
` as GeneratedQuery<
  APITypes.ListReportViewsQueryVariables,
  APITypes.ListReportViewsQuery
>;
export const listResourcesDetails = /* GraphQL */ `query ListResourcesDetails {
  listResourcesDetails {
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    resource_link
    resource_name
  }
}
` as GeneratedQuery<
  APITypes.ListResourcesDetailsQueryVariables,
  APITypes.ListResourcesDetailsQuery
>;
export const listScenarioSnapshots = /* GraphQL */ `query ListScenarioSnapshots {
  listScenarioSnapshots {
    created_at
    created_by
    planning_cycle_name
    planning_cycle_year
    scenario_name
    scenario_seq_id
    scenario_snapshot_id
    scenario_snapshot_name
    scenario_snapshot_note
    scenario_snapshot_time
    status
    updated_at
    updated_by
  }
}
` as GeneratedQuery<
  APITypes.ListScenarioSnapshotsQueryVariables,
  APITypes.ListScenarioSnapshotsQuery
>;
export const listScenarios = /* GraphQL */ `query ListScenarios {
  listScenarios {
    planning_cycle_name_list
    scenario_id
    scenario_name
  }
}
` as GeneratedQuery<
  APITypes.ListScenariosQueryVariables,
  APITypes.ListScenariosQuery
>;
export const listShippingAddresses = /* GraphQL */ `query ListShippingAddresses($org_id: String!, $region: String) {
  listShippingAddresses(org_id: $org_id, region: $region) {
    addresses {
      address
      country_code
      id
      label
    }
  }
}
` as GeneratedQuery<
  APITypes.ListShippingAddressesQueryVariables,
  APITypes.ListShippingAddressesQuery
>;
export const listTransferBudgetOwnershipLog = /* GraphQL */ `query ListTransferBudgetOwnershipLog {
  listTransferBudgetOwnershipLog {
    action
    cost_centers
    data_classification_id
    from_alias
    last_updated_at
    log_id
    number_of_forecast_inputs_updated
    performed_by
    status
    to_alias
  }
}
` as GeneratedQuery<
  APITypes.ListTransferBudgetOwnershipLogQueryVariables,
  APITypes.ListTransferBudgetOwnershipLogQuery
>;
export const listUsefulLifeDetails = /* GraphQL */ `query ListUsefulLifeDetails {
  listUsefulLifeDetails {
    cost_center_code
    created_at
    created_by
    data_classification_id
    expense_type
    is_active
    updated_at
    updated_by
    useful_life
    useful_life_id
  }
}
` as GeneratedQuery<
  APITypes.ListUsefulLifeDetailsQueryVariables,
  APITypes.ListUsefulLifeDetailsQuery
>;
export const listUserAccess = /* GraphQL */ `query ListUserAccess {
  listUserAccess {
    access_id
    corp_segment_access {
      segment_name
      segment_value
    }
    created_at
    created_by
    data_classification_id
    is_active
    updated_at
    updated_by
    user_alias
    user_name
    user_type
  }
}
` as GeneratedQuery<
  APITypes.ListUserAccessQueryVariables,
  APITypes.ListUserAccessQuery
>;
export const listUserMetricsDetails = /* GraphQL */ `query ListUserMetricsDetails {
  listUserMetricsDetails {
    created_at
    created_by
    metrics_name
    metrics_payload
  }
}
` as GeneratedQuery<
  APITypes.ListUserMetricsDetailsQueryVariables,
  APITypes.ListUserMetricsDetailsQuery
>;
export const listXVTSnapshots = /* GraphQL */ `query ListXVTSnapshots {
  listXVTSnapshots {
    created_at
    created_by
    planning_cycle_name
    planning_cycle_year
    scenario_name
    scenario_seq_id
    snapshot_name
    snapshot_note
    snapshot_time
    status
    updated_at
    updated_by
    xvt_snapshot_id
  }
}
` as GeneratedQuery<
  APITypes.ListXVTSnapshotsQueryVariables,
  APITypes.ListXVTSnapshotsQuery
>;
export const searchSuppliers = /* GraphQL */ `query SearchSuppliers($query: String!, $region: String) {
  searchSuppliers(query: $query, region: $region) {
    suppliers {
      display_name
      enabled_for_org
      entity_id
      ofa_vendor_number
      payment_terms
      po_country_code
      po_region
      supplier_currency
    }
  }
}
` as GeneratedQuery<
  APITypes.SearchSuppliersQueryVariables,
  APITypes.SearchSuppliersQuery
>;
